exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel,textarea{font-size:.8rem;letter-spacing:1px\n}\ntextarea{padding:10px;max-width:100%;line-height:1.5;border-radius:5px;border:1px solid #ccc;-webkit-box-shadow:1px 1px 1px #999;box-shadow:1px 1px 1px #999\n}\nlabel{display:block;margin-bottom:10px;font-weight:bold\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Reports.vue
// module id = Zf5S
// module chunks = 70